import styled from "@emotion/styled";
import { MergeWithOverwrite } from "src/common";

const IconSpan = styled.span({
  boxSizing: 'border-box',
  width: 30,
  height: 30,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '50%',
  transition: 'all 0.5s ease-in-out',
  cursor: 'pointer',

  'svg path': {
    fill: '#000000',
  },

  '&:hover': {
    transform: 'rotate(180deg)',
    backgroundColor: '#DBDBDB',

    'svg path': {
      fill: '#6A0098',
    },
  },
});

export type IconModalCloseProps = MergeWithOverwrite<React.HtmlHTMLAttributes<HTMLSpanElement>,{
  width?: number;
  height?: number;
  color?: string;
}>;

const IconModalClose: React.FC<IconModalCloseProps> = ({
  width = 24,
  height = 24,
  color = "#000000",
  ...props
}) => (
  <IconSpan {...props}>
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={width}
      height={height}
      viewBox="0 0 24 24" 
      fill="none"
    >
      <path 
        d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"
        fill={color}
        fillOpacity="0.56"
      />
    </svg>
  </IconSpan>
);

export default IconModalClose;